import React, { useState, useEffect } from "react";
// import Breadcrumbs from "../../core/breadcrumbs";
import { Link, useNavigate } from "react-router-dom";
import { Filter, Sliders, User, Globe } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import SupplierModal from "../../core/modals/peoples/supplierModal";
import Axios from "axios";
import {
  API_BASE_URL,
  GET_SUPPLIERS,
  INSERT_SUPPLIER,
  DELETE_SUPPLIER,
} from "../../Config";
import { setsuppliers_list } from "../../core/redux/action";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import SupplierViewModal from "../../core/modals/peoples/supplierviewModal";
import SpinLoader from "../loader/SpinLoader";

const Suppliers = () => {
  const data = useSelector((state) => state.toggle_header);
  const [userDataSession, setUserDataSession] = useState([]);
  const [rejectReason, setRejectReason] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const dataSource = useSelector((state) => state.suppliers_list);
  // const data = useSelector((state) => state.toggle_header);
  const dispatch = useDispatch();
  const [editSupplierObj, setEditSupplierObj] = useState([]);
  const [viewSupplierObj, setViewSupplierObj] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // #region Get suppliers
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(`${API_BASE_URL}${GET_SUPPLIERS}/${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status) {
            dispatch(setsuppliers_list(response.data.ResultData));
            console.log(response.data.ResultData, "sss sss");
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const filteredData = Array.isArray(dataSource)
    ? dataSource.filter(
        (item) =>
          (item && // Check if item is defined
            item.SupplierName &&
            item.SupplierName.toLowerCase().includes(
              searchQuery.toLowerCase()
            )) ||
          (item.ContactName &&
            item.ContactName.toLowerCase().includes(
              searchQuery.toLowerCase()
            )) ||
          (item.EmailId &&
            item.EmailId.toString()
              .toLowerCase()
              .includes(searchQuery.toLowerCase()))
      )
    : [];

  const options = [
    { value: "sortByDate", label: "Sort by Date" },
    { value: "140923", label: "14 09 23" },
    { value: "110923", label: "11 09 23" },
  ];
  const optionsTwo = [
    { label: "Choose Customer Name", value: "" },
    { label: "Benjamin", value: "Benjamin" },
    { label: "Ellen", value: "Ellen" },
    { label: "Freda", value: "Freda" },
    { label: "Kaitlin", value: "Kaitlin" },
  ];

  const countries = [
    { label: "Choose Country", value: "" },
    { label: "India", value: "India" },
    { label: "USA", value: "USA" },
  ];

  const columns = [
    {
      render: () => (
        <label className="checkboxs">
          <input type="checkbox" />
          <span className="checkmarks" />
        </label>
      ),
    },

    {
      title: "Name",
      dataIndex: "SupplierName",
      sorter: (a, b) => a.SupplierName.length - b.SupplierName.length,
    },

    {
      title: "Email",
      dataIndex: "EmailId",
      sorter: (a, b) => a.EmailId.length - b.EmailId.length,
    },

    {
      title: "Phone",
      dataIndex: "PhoneNo",
      sorter: (a, b) => a.PhoneNo.length - b.PhoneNo.length,
    },

    {
      title: "Contact Person",
      dataIndex: "ContactName",
      sorter: (a, b) => a.ContactName.length - b.ContactName.length,
    },

    {
      title: "Status",
      dataIndex: "Status",
      sorter: (a, b) => a.Status.length - b.Status.length,
      render: (text, record) => {
        let badgeClass;
        let badgeText;

        switch (record.Status) {
          case "Approved":
            badgeClass = "badge badge-linesuccess fs-6";
            badgeText = "Approved";
            break;
          case "Rejected":
            badgeClass = "badge bg-outline-danger fs-6";
            badgeText = "Rejected";
            break;
          case "Draft":
            badgeClass = "badge bg-outline-info fs-6";
            badgeText = "Draft";
            break;
          case "Pending":
            badgeClass = "badge bg-outline-warning fs-6";
            badgeText = "Pending";
            break;
          default:
            badgeClass = "badge bg-outline-dark fs-6";
            badgeText = record.Status;
        }

        return <span className={badgeClass}>{badgeText}</span>;
      },
    },

    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <td className="text-center">
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                data-bs-toggle="modal"
                data-bs-target="#view-supplier"
                onClick={() => showViewModal(record)}
              >
                <i className="fa-regular fa-eye me-2"></i>
                View
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className={`dropdown-item ${
                  record.Status === "Approved" ? "" : ""
                }`}
                data-bs-toggle="modal"
                data-bs-target="#edit-suppliers"
                onClick={() =>
                  // record.Status !== "Approved" &&
                  showEditModal(record)
                }
              >
                <i className="fa-regular fa-pen-to-square me-2"></i>
                Edit
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className={`dropdown-item ${
                  record.Status === "Approved" ? "disabled" : ""
                }`}
                onClick={() => showApproveConfirmationAlert(record.Id)}
              >
                <i className="fa-regular fa-circle-check me-2"></i>
                Approve
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className={`dropdown-item ${
                  record.Status === "Rejected" ? "disabled" : ""
                }`}
                onClick={() => showDeclineConfirmationAlert(record.Id)}
              >
                <i className="fa-regular fa-circle-xmark me-2"></i>
                Reject
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className={`dropdown-item confirm-text mb-0`}
                onClick={() => showConfirmationAlert(record.Id)}
              >
                <i className="fa-regular fa-trash-can me-2"></i>
                Delete
              </Link>
            </li>
          </ul>
        </td>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const showViewModal = (brandObj) => {
    setViewSupplierObj(brandObj);
  };

  const showEditModal = (brandObj) => {
    setEditSupplierObj(brandObj);
  };

  const MySwal = withReactContent(Swal);

  const showApproveConfirmationAlert = (supplierId) => {
    MySwal.fire({
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, Approve it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        Axios.post(`${API_BASE_URL}${INSERT_SUPPLIER}`, {
          orgid: userDataSession.OrgId,
          userid: userDataSession.UserId,
          Supplier: {
            Id: supplierId,
            Status: "Approved",
            UpdatedBy: userDataSession.UserId,
          },
          bank: [],
        })
          .then((response) => {
            console.log(response.data);
            MySwal.fire({
              title: "Success",
              text: "Supplier has been approved.",
              className: "btn btn-success",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-success",
              },
            }).then(() => {
              window.location.reload();
            });
          })
          .catch((error) => {
            console.error("Error:", error);
            MySwal.fire({
              title: "Error",
              text: "There was an error approving the supplier.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      } else {
        MySwal.close();
      }
    });
  };

  const showDeclineConfirmationAlert = (supplierId) => {
    MySwal.fire({
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonColor: "red",
      confirmButtonText: "Yes, Reject it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
      html:
        '<input id="reject-reason" class="swal2-input" placeholder="Reason for rejection" value="' +
        rejectReason +
        '">',
      focusConfirm: false,
      preConfirm: () => {
        return document.getElementById("reject-reason").value;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const reason = document.getElementById("reject-reason").value;
        setRejectReason(reason); // Update state with reason (optional)

        Axios.post(`${API_BASE_URL}${INSERT_SUPPLIER}`, {
          orgid: userDataSession.OrgId,
          userid: userDataSession.UserId,
          Supplier: {
            Id: supplierId,
            Status: "Rejected",
            UpdatedBy: userDataSession.UserId,
            Notes: reason,
          },
          bank: [],
        })
          .then((response) => {
            console.log(response.data);
            MySwal.fire({
              title: "Success",
              text: "Supplier has been rejected.",
              className: "btn btn-success",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-success",
              },
            }).then(() => {
              window.location.reload();
            });
          })
          .catch((error) => {
            console.error("Error:", error);
            MySwal.fire({
              title: "Error",
              text: "There was an error rejecting the supplier.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      } else {
        MySwal.close();
      }
    });
  };

  const showConfirmationAlert = (supplierId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        Axios.post(`${API_BASE_URL}${DELETE_SUPPLIER}`, {
          Id: supplierId,
          UpdatedBy: userDataSession.UserId,
        })
          .then((response) => {
            console.log(response.data);
            MySwal.fire({
              title: "Success",
              text: "Supplier has been deleted.",
              className: "btn btn-success",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-success",
              },
            }).then(() => {
              window.location.reload();
            });
          })
          .catch((error) => {
            console.error("Error:", error);
            MySwal.fire({
              title: "Error",
              text: "There was an error deleting the supplier.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      } else {
        MySwal.close();
      }
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleReload = () => {
    window.location.reload();
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: " suppliers",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = [
      "Supplier Name",
      "Email",
      "Phone",
      "Contact Person",
      "Status",
    ];
    tableData.push(headers);

    // Add rows
    dataSource.forEach((item) => {
      const row = [];
      row.push(
        item.SupplierName,
        item.EmailId,
        item.PhoneNo,
        item.ContactName,
        item.Status
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("suppliers.pdf");
  };

  const generateEXCEL = () => {
    if (dataSource.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Define headers for the worksheet
    const headers = [
      "Supplier Name",
      "Email",
      "Phone",
      "Contact Person",
      "Status",
    ];

    // Convert your data to worksheet format
    const wsData = dataSource.map((item) => ({
      "Supplier Name": item.SupplierName,
      Email: item.EmailId,
      Phone: item.PhoneNo,
      "Contact Person": item.ContactName,
      Status: item.Status,
    }));

    // Add headers as the first row
    wsData.unshift({
      "Supplier Name": headers[0],
      Email: headers[1],
      Phone: headers[2],
      "Contact Person": headers[3],
      Status: headers[4],
    });

    // Convert the data to a worksheet
    const ws = XLSX.utils.json_to_sheet(wsData, { skipHeader: true });

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "SuppliersData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "suppliers.xlsx");
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header transfer">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Supplier List</h4>
              <h6>Manage Your Supplier</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link onClick={generatePDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={generateEXCEL}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            {/* <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li> */}
            <li onClick={handleReload}>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="d-flex purchase-pg-btn">
            {/* <div className="page-btn">
                                <Link
                                    to="#"
                                    className="btn btn-added"
                                    data-bs-toggle="modal"
                                    data-bs-target="#new-purchase-invoice"
                                >
                                    <PlusCircle className="me-2"/> 
                                    Genearte New Invoice
                                </Link>
                            </div> */}
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <PlusCircle className="me-2" />
                Add New Supplier
              </Link>
            </div>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort stylewidth">
                <Sliders className="info-img" />

                <Select
                  className="select "
                  options={options}
                  placeholder="Sort by Date"
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? "" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "none" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <User className="info-img" />
                      <Select
                        options={optionsTwo}
                        placeholder="Choose Customer Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Globe className="info-img" />
                      <Select
                        options={countries}
                        placeholder="Choose Country"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                    <div className="input-blocks">
                      <a className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              {loading ? (
                <SpinLoader />
                // <div className="loader m-auto"></div>
              ) : (
                <Table
                  className="table datanew"
                  columns={columns}
                  dataSource={filteredData}
                  rowKey={(record) => record.id}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <SupplierModal supplierObj={viewSupplierObj} />  */}
      <SupplierModal supplierObj={editSupplierObj} />
      <SupplierViewModal supplierObj={viewSupplierObj} />
    </div>
  );
};

export default Suppliers;
